/*
 * @Description: 代理系统
 * @Author: gao shuai
 * @Date: 2020-05-18 15:20:58
 * @LastEditTime: 2020-08-18 10:48:08
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  /* --------------------------1.下属商户---------------------------- */
  // 下属商户列表
  async submerchantList(params) {
  return api({ url: '/api/HomePage/GetAgentMerchantListAsync', method: 'get', params });
  },
  // 代理下的登录
  async agentLogin(params) {
  return api({ url: '/api/HomePage/MerchantLoginAsync', method: 'post', data: params });
  },
  // 添加商户
  async addMerchant(params) {
  return api({ url: '/api/UserManage/AddMerchantAsync', method: 'post', data: params });
  },
  // 比率组下拉
  async rankDraw(params) {
  return api({ url: '/api/HomePage/GetAgentMerchantRankTitlesAsync', method: 'get', params });
  },
  // 更新商户状态
  async stateChange(params) {
  return api({ url: '/api/HomePage/UpdateMerchantStateAsync', method: 'post', data: params });
  },
  // 切换代理商户
  async rankChange(params) {
  return api({ url: '/api/HomePage/SwitchAgentMerchantRankAsync', method: 'post', data: params });
  },
  // 删除下属商户
  async delMerchant(params) {
  return api({ url: '/api/HomePage/DeleteAgentMerchantAsync', method: 'post', data: params });
  },
  /* --------------------------2.代理订单---------------------------- */
  // 支付方式
  async paydraw(params) {
  return api({ url: '/api/SelectDropDown/GetPayModeNameListAsync', method: 'get', params });
  },
  // 下属商户下拉
  async subMerchantdraw(params) {
  return api({ url: '/api/HomePage/GetAgentMerchantAsync', method: 'get', params });
  },
  // 获取代理下的订单列表
  async orderList(params) {
  return api({ url: '/api/HomePage/GetAgentOrdersAsync', method: 'get', params });
  },
  // 获取代理下的统计
  async orderStatic(params) {
  return api({ url: '/api/HomePage/GetAgentOrderStatisticsViewAsync', method: 'get', params });
  },
  /* --------------------------3.用户分组---------------------------- */
  // 用户分组列表
  async userList(params) {
  return api({ url: '/api/HomePage/GetAgentMerchantRankListAsync', method: 'get', params });
  },
  // 切换默认
  async userDefalut(params) {
  return api({ url: '/api/HomePage/ChangeDefaultRankAsync', method: 'post', data: params });
  },
  // 添加代理费率列表
  async productList(params) {
  return api({ url: '/api/HomePage/GetAddDefaultProductRateAsync', method: 'get', params });
  },
  // 添加代理费率
  async addrank(params) {
  return api({ url: '/api/HomePage/AddRankAsync', method: 'post', data: params });
  },
  // 获取编辑时的数据
  async editInfo(params) {
  return api({ url: '/api/HomePage/GetUpdateProductRateAsync', method: 'get', params });
  },
  // 编辑代理费率
  async eidtrank(params) {
  return api({ url: '/api/HomePage/UpdateRankAsync', method: 'post', data: params });
  },
  // 删除费率
  async delRank(params) {
  return api({ url: '/api/HomePage/DeleteRankAsync', method: 'post', data: params });
  },
  // 费率设置时的大小限制
  async numLimit(params) {
  return api({ url: '/api/HomePage/GetAgentDefaultProductLimitRateAsync', method: 'get', params });
  },
  /* --------------------------4.分区管理---------------------------- */
  // 分区管理列表
  async agentmanageList(params) {
  return api({ url: '/api/PartitionsManager/GetAgentMerchantPartitionsListAsync', method: 'get', params });
  },
  /* --------------------------5.数据统计---------------------------- */
  // 每日收益统计列表
  async dayStatis(params) {
  return api({ url: '/api/DataAnalysis/GetAgentDailyIncomeAsync', method: 'get', params });
  },
  // 每日收益统计列表
  async staticsDetail(params) {
  return api({ url: '/api/DataAnalysis/GetAgentDailyIncomeResultAsync', method: 'get', params });
  },
  // 充值排行
  async chargeRank(params) {
  return api({ url: '/api/DataAnalysis/GetAgentMerchantIncomeAsync', method: 'get', params });
  }
};
